import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiService } from '@services/api.service';
import { LoteLancamentos } from '../models/lote-lancamentos';

@Injectable({
  providedIn: 'root'
})
export class EditarLoteLancamentosApiService extends ApiService {

  baseUrlRoute: string = "cadastro-lote-lancamentos";

  constructor(
    public override http: HttpClient,
  ) {
    super(http);
  }

  public salvarLoteLancamentos(loteLancamentos: LoteLancamentos): Observable<void> {
    if (loteLancamentos.id === 0)
      return this.post<void>(`/${this.baseUrlRoute}`, null, loteLancamentos);
    else
      return this.put<void>(`/${this.baseUrlRoute}`, null, loteLancamentos);
  }

  public getLoteLancamentosNomeData(nome: string, data: string): Observable<LoteLancamentos> {
    return this.get<LoteLancamentos>(`/${this.baseUrlRoute}`, { nome, data });
  }
}
